const districts = [
    "500000",
    "441900",
    "440600",
    "420100",
    "410100",
    "430100",
    "320100",
    "320500",
    "210100",
    "510100",
    "370200",
    "610100",
    "120000",
    "330100",
    "330200",
    "340100",
    "350100",
    "350500",
    "350200",
    "441300",
    "440400",
    "442000",
    "620100",
    "450100",
    "520100",
    "130100",
    "230100",
    "220100",
    "320400",
    "320600",
    "320200",
    "320300",
    "360100",
    "210200",
    "370100",
    "371300",
    "370700",
    "370600",
    "140100",
    "530100",
    "330700",
    "330400",
    "330600",
    "331000",
    "330300",
    "340800",
    "340300",
    "341100",
    "341200",
    "341500",
    "340500",
    "340200",
    "350900",
    "350300",
    "350400",
    "350600",
    "445100",
    "440700",
    "445200",
    "440900",
    "441800",
    "440500",
    "440800",
    "441200",
    "450300",
    "450200",
    "520300",
    "130600",
    "130900",
    "130400",
    "131000",
    "130300",
    "130200",
    "130500",
    "421000",
    "420600",
    "420500",
    "230600",
    "460100",
    "460200",
    "410300",
    "411300",
    "411400",
    "410700",
    "411500",
    "411600",
    "411700",
    "430400",
    "430600",
    "430200",
    "320800",
    "320700",
    "321300",
    "321200",
    "320900",
    "321000",
    "321100",
    "360700",
    "360400",
    "361100",
    "360900",
    "210300",
    "150100",
    "640100",
    "510700",
    "371400",
    "371700",
    "370800",
    "371000",
    "370300",
    "610400",
    "650100",
    "330500",
    "331100",
    "330900",
    "341600",
    "340400",
    "341000",
    "341300",
    "340700",
    "341800",
    "350800",
    "350700",
    "441600",
    "441400",
    "440200",
    "441500",
    "445300",
    "441700",
    "450500",
    "450400",
    "450900",
    "520400",
    "520500",
    "522600",
    "522700",
    "520600",
    "130800",
    "131100",
    "130700",
    "422800",
    "421100",
    "420200",
    "420300",
    "420900",
    "421200",
    "230200",
    "231200",
    "410500",
    "410800",
    "410200",
    "411100",
    "410400",
    "411000",
    "430700",
    "431000",
    "431200",
    "431300",
    "430500",
    "430300",
    "430900",
    "431100",
    "220200",
    "222400",
    "361000",
    "360800",
    "360200",
    "360600",
    "210600",
    "211400",
    "210700",
    "211100",
    "210800",
    "150200",
    "150400",
    "150600",
    "630100",
    "510600",
    "511100",
    "510500",
    "511400",
    "511300",
    "511500",
    "371600",
    "370500",
    "371500",
    "371100",
    "370900",
    "370400",
    "610300",
    "610500",
    "610600",
    "610800",
    "140400",
    "140200",
    "140700",
    "141000",
    "141100",
    "140800",
    "540100",
    "532900",
    "532500",
    "530300",
    "530600",
    "330800",
    "341700",
    "340600",
    "620400",
    "621100",
    "623000",
    "620300",
    "620900",
    "620200",
    "621200",
    "622900",
    "620800",
    "621000",
    "620500",
    "620600",
    "620700",
    "451000",
    "451400",
    "450600",
    "450800",
    "451200",
    "451100",
    "451300",
    "450700",
    "520200",
    "522300",
    "420700",
    "420800",
    "429005",
    "429021",
    "421300",
    "429006",
    "429004",
    "232700",
    "230400",
    "231100",
    "230800",
    "230300",
    "231000",
    "230900",
    "230500",
    "230700",
    "469025",
    "469029",
    "469026",
    "469023",
    "469021",
    "469007",
    "460400",
    "469027",
    "469024",
    "469028",
    "469002",
    "469030",
    "460300",
    "469022",
    "469005",
    "469006",
    "469001",
    "410600",
    "419001",
    "410900",
    "411200",
    "433100",
    "430800",
    "220800",
    "220600",
    "220400",
    "220300",
    "220700",
    "220500",
    "360300",
    "360500",
    "210500",
    "211300",
    "210400",
    "210900",
    "211000",
    "211200",
    "152900",
    "150800",
    "150700",
    "150500",
    "150300",
    "150900",
    "152200",
    "152500",
    "640400",
    "640200",
    "640300",
    "640500",
    "632600",
    "632200",
    "630200",
    "632500",
    "632300",
    "632800",
    "632700",
    "513200",
    "511900",
    "511700",
    "511600",
    "510800",
    "513300",
    "513400",
    "511000",
    "510400",
    "510900",
    "511800",
    "510300",
    "512000",
    "610900",
    "610700",
    "611000",
    "610200",
    "140500",
    "140600",
    "140900",
    "140300",
    "652900",
    "659002",
    "654300",
    "652700",
    "659005",
    "652800",
    "652300",
    "650500",
    "653200",
    "659010",
    "659008",
    "650200",
    "653100",
    "659009",
    "653000",
    "659007",
    "659001",
    "654200",
    "650400",
    "659006",
    "659003",
    "659004",
    "654000",
    "542500",
    "540300",
    "540400",
    "542400",
    "540200",
    "540500",
    "530500",
    "532300",
    "533100",
    "533400",
    "530900",
    "530700",
    "533300",
    "530800",
    "532600",
    "532800",
    "530400",
    "1821274",
    "1819729",
    "7280291"
]

export default districts
